import AcceptedPaymentMethodsProvider from './hooks/useAcceptedPaymentMethods';

import { AcceptedPaymentMethodsProps } from './@types/AcceptedPaymentMethodsProps';
import AcceptedPaymentMethodsContainer from './handles/AcceptedPaymentMethodsContainer';
import PaymentMethodIcon from './handles/PaymentMethodIcon';
import PaymentMethodIconImage from './handles/PaymentMethodIconImage';

const AcceptedPaymentMethods = (props: AcceptedPaymentMethodsProps) => (
	<AcceptedPaymentMethodsProvider {...props}>
		<AcceptedPaymentMethodsContainer>
			{props.paymentMethods?.map((item, index) => (
				<PaymentMethodIcon key={`${item}-${index}`}>
					<PaymentMethodIconImage showInColor={props.showInColor} paymentMethod={item} />
				</PaymentMethodIcon>
			))}
		</AcceptedPaymentMethodsContainer>
	</AcceptedPaymentMethodsProvider>
);

export default AcceptedPaymentMethods;
